import React from 'react';
import "../banner.css";
import { ADSERVER_ID, isProdEnv } from '@/_constant/appConstant';

const BottomBanner = ({stateIds}) => {

  return (
    <div key={stateIds} className="bg-light py-3">
      <div className='container'>
        <div className='d-flex align-items-center flex-column flex-lg-row gap-1'>
          <div className='flex-fill banner-box'>
            <ins data-revive-state-id={stateIds} data-revive-zoneid={isProdEnv() ? "1": "10"} data-revive-id={ADSERVER_ID}></ins>
          </div>
          <div className='flex-fill banner-box'>
            <ins data-revive-state-id={stateIds} data-revive-zoneid={isProdEnv() ? "2" : "11"} data-revive-id={ADSERVER_ID}></ins>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBanner;
